module.exports = __webpack_public_path__ + "media/images/need-a-resume-d16ed3fd930c8f9aceb4c9610a4559e2.svg";